import _ from 'lodash';

import { Observable, BehaviorSubject } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { LineupReleaseNotes } from 'src/app/home/models/LineupReleaseNotes';
import { ApiVersions } from './api-version';

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseService {
  private _releases: BehaviorSubject<LineupReleaseNotes[]> = new BehaviorSubject<
    LineupReleaseNotes[]
  >([]);

  public readonly releases: Observable<LineupReleaseNotes[]> = this._releases.asObservable();

  constructor() {
    super();
  }

  getReleases(): Observable<LineupReleaseNotes[]> {
    let obs = this.get(this.releasesBaseUrl(), null, ApiVersions.unversioned)
      .pipe(publishLast())
      .pipe(refCount());

    obs.subscribe((releases) => {
      this._releases.next(releases);
    });

    return obs;
  }

  deleteRelease(releaseId: string): Observable<any> {
    return this.delete(
      this.releasesBaseUrl().concat(`/${releaseId}`),
      null,
      ApiVersions.unversioned
    ).pipe(
      map((result) => {
        this.getReleases();
        return result;
      })
    );
  }

  createRelease(release: LineupReleaseNotes): Observable<any> {
    let releaseStream = JSON.stringify(release);
    return this.post(this.releasesBaseUrl(), releaseStream, null, ApiVersions.unversioned).pipe(
      map((result) => {
        this.getReleases();
        return result;
      })
    );
  }

  updateRelease(releaseId: string, release: LineupReleaseNotes): Observable<any> {
    let releaseStream = JSON.stringify(release);
    return this.put(
      this.releasesBaseUrl().concat(`/${releaseId}`),
      releaseStream,
      null,
      ApiVersions.unversioned
    ).pipe(
      map((result) => {
        this.getReleases();
        return result;
      })
    );
  }

  private releasesBaseUrl() {
    return 'lineup-releasenotes';
  }
}
